import * as React from "react";

import {
  Box,
  Slide,
  Stack,
  DialogContent,
  Dialog,
  Divider,
  Typography,
  Avatar,
  IconButton,
  Button,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import {
  fullName,
  getUserId,
  isOwnerId,
  kFormatter,
} from "../../constants/function";
import NoData from "./../../components/Nodata";
import { Images } from "../../assets/common";
import NftList from "../DirectChat/nftList";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import GroupRemoveIcon from "@mui/icons-material/GroupRemove";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import { useTranslation } from "react-i18next";
import { SocketContext } from "../../context/socket";
import "./index.scss";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function TopListPopup({
  open,
  handleClose,
  image,
  data,
  error,
  isTip,
  isArray,
  title,
  isLiveUser,
  isUsers,
  onTipPoupOpen,
  onNftPoupOpen,
  onRequestToHost,
  isOwner,
  onHandleMute,
  onToggleCamera,
  channelName,
  followings,
  obs,
}) {
  const { t } = useTranslation("common");
  const [index, setIndex] = React.useState(null);

  const popupTitle = title
    ? title
    : isTip
    ? t("topListPopup.title1")
    : t("topListPopup.title2");

  return (
    <Box color="default">
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose()}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          className: "hud-toplist-dialog",
        }}
        BackdropProps={{
          className: "hud-toplist-backdrop",
        }}
      >
        {/* Header */}
        <div className="hud-toplist-header">
          <div className="hud-toplist-header-left">
            {!title && image && (
              <img className="hud-toplist-header-icon" src={image} alt="icon" />
            )}
            <span className="hud-toplist-title">{popupTitle}</span>
          </div>
          <button className="hud-toplist-close" onClick={() => handleClose()}>
            <CloseOutlinedIcon sx={{ fontSize: 18, color: "#6A6A80" }} />
          </button>
        </div>

        {/* Content */}
        <DialogContent className="hud-toplist-content">
          <Stack spacing={0}>
            {!isLiveUser && !isUsers && data && data.length > 0 ? (
              data.map((m, idx) => (
                <div key={idx} className={`hud-toplist-row ${idx < 3 ? 'hud-toplist-row--top' : ''}`}>
                  <span className={`hud-toplist-rank ${idx < 3 ? 'hud-toplist-rank--gold' : ''}`}>
                    {idx + 1}
                  </span>
                  <Avatar
                    className="hud-toplist-avatar"
                    src={m["profileImg"] ? m["profileImg"]["filePath"] : null}
                  />
                  <div className="hud-toplist-info">
                    <Typography className="hud-toplist-name">{fullName(m)}</Typography>
                    <Typography className="hud-toplist-meta">
                      {kFormatter(m["followers"])} {t("topListPopup.text1")}
                    </Typography>
                  </div>
                </div>
              ))
            ) : isLiveUser && data && data.length > 0 ? (
              data.map((m, idx) => (
                <div key={idx} className={`hud-toplist-row ${idx < 3 ? 'hud-toplist-row--top' : ''}`}>
                  <span className={`hud-toplist-rank ${idx < 3 ? 'hud-toplist-rank--gold' : ''}`}>
                    {idx + 1}
                  </span>
                  <Avatar
                    className="hud-toplist-avatar"
                    src={m["profilePic"] ? m["profilePic"]["filePath"] : null}
                  />
                  <div className="hud-toplist-info">
                    <Typography className="hud-toplist-name">{m["fullName"]}</Typography>
                  </div>
                  {isUsers && !isOwnerId(m?._id) && onTipPoupOpen && (
                    <Box
                      onClick={(e) => {
                        e.stopPropagation();
                        onTipPoupOpen(m);
                      }}
                      sx={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        padding: "4px",
                        marginLeft: "auto",
                        "&:hover": { opacity: 0.7 },
                      }}
                    >
                      <img
                        title="Tip"
                        style={{ width: "24px", pointerEvents: "none" }}
                        src={Images.tipOwner}
                        alt="tip"
                      />
                    </Box>
                  )}
                </div>
              ))
            ) : isUsers && data && data.length > 0 ? (
              data.map((m, idx) => (
                <div key={idx} className={`hud-toplist-row ${idx < 3 ? 'hud-toplist-row--top' : ''}`}>
                  <span className={`hud-toplist-rank ${idx < 3 ? 'hud-toplist-rank--gold' : ''}`}>
                    {idx + 1}
                  </span>
                  <Avatar
                    className="hud-toplist-avatar"
                    src={m?.user?.profileImg?.filePath || Images.default_user}
                  />
                  <div className="hud-toplist-info">
                    <Typography className="hud-toplist-name">
                      {fullName(m?.user)}
                    </Typography>
                  </div>
                  <Stack direction="row" alignItems="center" spacing={1} sx={{ marginLeft: "auto" }}>
                    {isOwnerId(m?.user?._id) ? null : (
                      <img
                        title="Tip"
                        onClick={() => onTipPoupOpen(m?.user)}
                        style={{ width: "24px", cursor: "pointer" }}
                        src={Images.tipOwner}
                        alt=""
                      />
                    )}
                    {!isOwner ? null : obs ? null : isOwnerId(
                        m?.user?._id
                      ) ? null : m?.user?.role === "audience" ? (
                      <IconButton
                        title="Make co-host"
                        onClick={() =>
                          onRequestToHost(m?.user._id, idx, m?.user)
                        }
                        sx={{ padding: "4px" }}
                      >
                        <GroupAddIcon
                          sx={{ width: "20px", color: "var(--hud-accent, #FFEE20)" }}
                        />
                      </IconButton>
                    ) : (
                      <IconButton
                        title="Make audience"
                        onClick={() =>
                          onRequestToHost(m?.user._id, idx, m?.user)
                        }
                        sx={{ padding: "4px" }}
                      >
                        <GroupRemoveIcon
                          sx={{ width: "20px", color: "#6A6A80" }}
                        />
                      </IconButton>
                    )}
                    {isOwnerId(m?.user?._id) ? null : (
                      <StreamFollow
                        channelName={channelName}
                        followings={followings}
                        _id={m?.user?._id}
                      />
                    )}
                  </Stack>
                </div>
              ))
            ) : (
              <Box sx={{ position: "relative", py: 3 }}>
                <NoData lable={t("noData.noData")} />
              </Box>
            )}
          </Stack>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export function StreamFollow({ followings, _id, channelName }) {
  const { t } = useTranslation("common");
  const socket = React.useContext(SocketContext).Socket;
  const isFollow = followings.filter((follower) => follower === _id);
  const userId = getUserId();
  const handleFollow = () => {
    if (socket) {
      socket.emit("follow", {
        _id: userId,
        following: _id,
        channelName: channelName,
        status: isFollow.length > 0 ? false : true,
      });
    }
  };
  return (
    <Button
      className="hud-toplist-follow-btn"
      variant={isFollow.length > 0 ? "contained" : "outlined"}
      onClick={handleFollow}
    >
      {isFollow.length > 0
        ? t("follow.followList.button2")
        : t("follow.followList.button1")}
    </Button>
  );
}
